export * from './lib/signature-pad.module';
export * from './lib/signature-drawer.directive';
